'use strict';

const CustomSlider = (($) => {

    const NAME = 'customSlider';
    const JQUERY_NO_CONFLICT = $.fn[NAME];

    const Default = {}

    class CustomSlider {

        // totalWidth = 0;

        static get Default() {
            return Default
        }

        constructor($element, config) {
            this._config = $.extend({}, Default, config);
            this.$element = $element;
            this.container = $element.find('> .container');
            console.log(this.container);

            this.fadeDuration = 2000;
            this.intervalId;

            this.position = 0;
            this.isSliding = false;

            this.init();
            this.addEventListeners();

            var _ = this;
        }

        init() {
            console.log('custom slider');

            // this.container.css('position', 'relative');
            this.container.addClass('custom-slider');

            this.container.find('> div').wrap('<div></div>');

            this.container.find('> div').eq(0).addClass('active');
            this.setHeight();

            this.startAutoRun();
        }

        addEventListeners() {
            var _self = this;

            this.$element.on('click', function (e) {
                _self.handleClick()
            });

            $(window).on('resize', function() {
                _self.resetHeight();
            })
        }

        handleClick(e) {
            // console.log('mouse click');
            this.showNext();
            this.restartAutoRun();
        }

        setHeight() {
            var ulHeight = this.container.height();
            ulHeight = this.container.find('> div.active > div').height();
            console.log(ulHeight);

            // this.container.attr('style', 'height: ' + ulHeight + 'px');
            this.container.css('height', ulHeight + 'px')
            this.container.addClass('initialized');

            // console.log(ulHeight);
        }

        resetHeight(slide) {
            var ulHeight = this.container.find('> div.active > div').height();

            if (slide) {
                slide.addClass('active');
                slide.show();
                ulHeight = slide.find('> div').height();
                slide.hide();
                slide.removeClass('active');
                console.log(ulHeight);
            }
            //
            this.container.attr('style', 'height: ' + ulHeight + 'px');
            this.container.addClass('initialized');

            // console.log(ulHeight);
        }

        startAutoRun() {
            this.intervalId = setInterval($.proxy(this.showNext, this), 10000);
        }

        restartAutoRun() {
            clearInterval(this.intervalId);
            this.startAutoRun();
        }

        showNext() {
            var _self = this;

            if (this.isSliding) {
                return;
            }
            this.isSliding = true;

            var activeSlide = this.container.find('> div.active');
            var nextSlide = activeSlide.next();
            // console.log(nextSlide);

            if (nextSlide.length === 0) {
                nextSlide = this.container.find('> div').eq(0);
            }

            _self.resetHeight(nextSlide);

            activeSlide.fadeOut(_self.fadeDuration, 'swing');
            nextSlide.fadeIn(
                _self.fadeDuration,
                'swing',
                function() {
                    _self.isSliding = false;
                    _self.container.find('> div').removeClass('active');
                    nextSlide.addClass('active');
                    // _self.resetHeight(nextSlide);
                }
            )
        }

        static _jQueryInterface(config) {
            config = config || {};
            return this.each(() => {
                let $this = $(this);
                let _config = $.extend(
                    {},
                    CustomSlider.Default,
                    $this.data(),
                    typeof config === 'object' && config
                );

                new CustomSlider(this, _config)
            })
        }
    }

    $.fn[NAME] = CustomSlider._jQueryInterface;
    $.fn[NAME].Constructor = CustomSlider;
    $.fn[NAME].noConflict = () => {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return CustomSlider._jQueryInterface
    };

    return CustomSlider;

})(jQuery);

export default CustomSlider;